/* jslint browser: true,  devel: true */
import Swiper from "lib/swiper";

console.warn("News controller file");

var newsController = [
  "$q",
  "$scope",
  "$state",
  "$stateParams",
  "newsApi",
  "$timeout",
  "apiFiles",
  "$templateCache",
  "$rootScope",
  function(
    $q,
    $scope,
    $state,
    $stateParams,
    newsApi,
    $timeout,
    apiFiles,
    $templateCache,
    $rootScope
  ) {
    console.log("NewsCtrl:init as News");
    var ctrl = this;

    console.warn("Swiper", { "window.Swiper": window.Swiper, Swiper });

    $scope.$root.currentTitle = {};

    $scope.go = $state.go;

    $scope.loading = true;

    const newsDate = a => a.publishStartDate || a.createDate;
    const newsComp = (a, b) => {
      const pDiff = a.priorityValue - b.priorityValue;
      return pDiff !== 0 ? pDiff : newsDate(b) - newsDate(a);
    };

    const loadArticles = () => {
      newsApi.list(undefined, { bypassCache: false }).then(articles => {
        articles.sort(newsComp);
        this.recentArticles = articles.filter(a => a.isNewsArticle);
        $scope.loading = false;
        if ($scope.onFeedLoaded) {
          $scope.onFeedLoaded();
          // if (!window._feedImagesLoaded) {
          //   const images = this.recentArticles
          //     .slice(0, 4)
          //     .map(a => $scope.getPreview(a))
          //     .filter(x => x);
          //   let pending = images.length;
          //   const onload = () => {
          //     pending--;
          //     if (!pending) {
          //       $scope.onFeedLoaded();
          //       window._feedImagesLoaded = true;
          //     }
          //   };
          //   images.forEach(url => {
          //     const img = document.createElement("img"); //new Image();
          //     img.onload = onload;
          //     img.src = url;
          //     img.style = "visibility: hidden; position: absolute;";
          //     document.body.append(img);
          //     // window._feedImages.push(img);
          //   });
          // } else {
          //   $scope.onFeedLoaded();
          // }
        }
        articles.forEach(a => {
          a.previewText = a.previewText || a.fullText.substr(0, 150) + "...";
          a.previewImgUrl = a.previewImgUrl || a.fullImgUrl;
          const pubDate = a.publishStartDate || a.createDate;
          a.publishedDate = moment(pubDate).format("LL");
        });
      });
    };

    loadArticles();

    $scope.loading = !(ctrl.recentArticles && ctrl.recentArticles.length > 0);

    $scope.$on("$stateChangeSuccess", function(
      event,
      newstate,
      newparams,
      oldstate,
      oldparams
    ) {
      if (newparams.articleId) {
        // updateArticle(newparams.articleId);
      } else {
        $scope.$root.currentTitle = {};
        ctrl.article = undefined;
      }
    });

    $scope.toggleLike = function(article, $event) {
      article._processing = true;
      $event.preventDefault();
      $event.stopPropagation();
      return newsApi
        .toggleArticleLike(article.id, !article.likedByCurrentUser)
        .then(() => {
          loadArticles();
        });
    };

    $scope.feedArticles = () => {
      return $scope.News.recentArticles.slice(0, 5);
    };

    $templateCache.put("Feed1", require("../views/desktop/feed1.html"));
    $templateCache.put("Feed2", require("../views/desktop/feed2.html"));
    $scope.getFeedTemplate = () => {
      return "Feed" + ($rootScope.appLayout.newsFeedTemplate || 1);
    };

    $scope.imageURLs = {};
    $scope.getPreview = function(article) {
      if (!article) return "";
      const url = article.previewImgUrl || article.fullImgUrl;
      if (!article.imageWasUploaded) {
        return url;
      }
      if (!$scope.imageURLs[url]) {
        $scope.imageURLs[url] = {};
        apiFiles.getLocalURL(url).then(imgUrl => {
          $scope.imageURLs[url].url = imgUrl;
        });
      }
      return $scope.imageURLs[url] && $scope.imageURLs[url].url;
    };

    $scope.getTextPreview = (article, forFeed) => {
      const limit = window.isMobile ? 150 : forFeed ? 260 : 500;
      const stripped = article.fullText
        .replace(
          /<\/?[a-zA-z0-9:-]+( +[a-zA-z0-9:_-]+ *= *('[^']+'|"[^"]+"))* *\/?>/g,
          " "
        )
        .replace(/<!--.+?-->/g, "")
        .replace(/&[^;]+;/g, " ");
      return stripped.length <= limit
        ? stripped
        : stripped.substr(0, limit) + "...";
    };
  }
];

window.app.controller("NewsCtrl", newsController);



// WEBPACK FOOTER //
// ./src/apps/news/controllers/news.js